import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PageWidget, PageWidgetProps } from './PageWidget';
import { JourneyParams, resolveRouteItems } from '../../routes';
import { useOrgStore } from '../../hooks/useOrgStore';
import { styled } from '../../theme';
import { SmartOrgSelectWidget } from '../../widgets-smart/SmartOrgSelectWidget';
import { observer } from 'mobx-react';
import { usePermissions } from '../../hooks/usePermissions';
import { ADMIN_SIDEBAR_ITEMS } from '../../pages/admin/AdminLandingPage';
import { satisfies } from '@journeyapps-platform/types-cardinal';
import { CardinalModel } from '@journeyapps-platform/cardinal-catalog';

export interface OrgPageWidgetProps extends Omit<PageWidgetProps, 'items' | 'title'> {
  activeItemKey?: string;
}

export const OrgPageWidget: React.FC<React.PropsWithChildren<OrgPageWidgetProps>> = observer((props) => {
  const params = useParams() as JourneyParams;
  const orgStore = useOrgStore();
  const permissions = usePermissions();

  return (
    <PageWidget
      loading={!orgStore.current_org || props.loading}
      {...props}
      items={resolveRouteItems(
        ADMIN_SIDEBAR_ITEMS.map((s) => {
          let allowed = true;
          if (s.authorization) {
            if (s.authorization.model === CardinalModel.ORG) {
              allowed = satisfies(permissions || [], s.authorization.action, {
                selector: {
                  model: s.authorization.model,
                  id: orgStore.current_org?.org_id!
                }
              });
            } else {
              allowed = satisfies(permissions || [], s.authorization.action, {
                scope: orgStore.current_org?.org_id,
                selector: {
                  model: s.authorization.model,
                  id: '*'
                }
              });
            }
          }
          return {
            key: s.path,
            disabled: !allowed,
            path: s.path,
            label: s.label
          };
        }),
        params
      )}
      locked={props.locked ?? orgStore.current_org?.model.locked}
      title={
        <S.OrgSelectBox>
          <S.OrgSelect />
        </S.OrgSelectBox>
      }
    >
      {props.children}
    </PageWidget>
  );
});

namespace S {
  export const OrgSelect = styled(SmartOrgSelectWidget)`
    width: 340px;
    max-width: 480px;
    margin-left: 20px;
  `;

  export const OrgSelectBox = styled.div`
    font-size: 21px;
    flex-grow: 1;
  `;
}
